import {useState} from 'react';
import {customFeed} from "../api";
import {PostList} from '../post/postList';
import '../post/style/postfeed.css'
import {useTranslation} from "react-i18next";

function PostsTrending({id, category, bookmarks, number, users}){
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [cursor, setCursor] = useState('');
  const [init, setInit] = useState(false);


  let search = {contact: [], entity: [], theme: []};
  search[category].push(id)


  if(!init){
    setInit(true);
    getCustomFeed();
  }

  function getCustomFeed(){
    if(cursor!==false){
      customFeed(cursor, search.contact, search.entity, search.theme).then(data => {
        setCursor(data.cursor);
        setPosts(posts.concat(data.data));
      });
    }
  }

  return (
    <>
      <div className="c-posts_header">
        <p>{t('Sujet à la Une')}</p>
        <span>
          {t('Ajouté il y a')} {number} {number === 1 ? t('jour') : t('jours')}
        </span>
      </div>
      <div className="c-posts_contactList">
        { posts.length > 0
            && <PostList users={users} apiCall={getCustomFeed} bookmarks={bookmarks} posts={posts}/>
        }

      </div>
    </>
  )
}


export default PostsTrending
